import * as React from "react";
import { ImageWithFallbacks } from "../common/ImageWithFallbacks";
import missingImageUrl from "../../../assets/images/missing-image.svg";
import type { ImageSources } from "../../model/ArticleTypes";

type Props = {
	article: ArticleBadgeImageItemView;
};

export type ArticleBadgeImageItemView = {
	bundleId: string;
	imageSources: ImageSources;
};

export function getUrls(article: ArticleBadgeImageItemView): string[] {
	const imageSources = article.imageSources;

	if (!imageSources) {
		return [];
	}

	return [
		imageSources.imageUrlL,
		imageSources.imageUrlS,
		imageSources.imageUrl1,
		imageSources.imageUrl2,
		imageSources.imageUrl3,
		missingImageUrl,
	].filter((url): url is string => !!url);
}

/**
 * Component that renders the image, name and display of an article.
 * Url handling copied from ShoppingCartArticleImage.
 */
export const ArticleBadgeImage = ({ article }: Props) => (
	<div className="article-image">
		<div className="h4 item-image item-component test-article-badge-image">
			<ImageWithFallbacks urls={getUrls(article)} width={90} height={90} />
		</div>
	</div>
);
